// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Image, Table } from "react-bootstrap";

// import logo from "../../../../assets/images/Logo.png";
// import axios from "axios";
// import Apiurl from "../../../environment/Apiurl";
// import { useParams, useNavigate } from "react-router-dom";

// const Prescriptionbill = () => {
//   const handlePrint = () => {
//     window.print();
//   };
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [responseData, setResponseData] = useState(null);
//   const [visitCount, setVisitCount] = useState(0);

//   // Fetch prescription or appointment data
//   const fetchPrescriptionData = async () => {
//     try {
//       console.log("Fetching data for ID:", id);
//       console.log("ID type:", typeof id);
//       console.log("ID length:", id?.length);

//       // First, try to get all prescriptions and find the matching one
//       try {
//         console.log("Trying to fetch all prescriptions and filter...");
//         const allPrescriptionsResponse = await axios.get(
//           `${Apiurl}/prescriptions`
//         );
//         if (
//           allPrescriptionsResponse.status === 200 &&
//           Array.isArray(allPrescriptionsResponse.data)
//         ) {
//           const matchingPrescription = allPrescriptionsResponse.data.find(
//             (prescription) => prescription._id === id || prescription.id === id
//           );

//           if (matchingPrescription) {
//             console.log("Found matching prescription:", matchingPrescription);
//             setResponseData(matchingPrescription);

//             // Fetch visit count based on patient_id
//             const patientId =
//               matchingPrescription?.appointment?.patient?.patient_id ||
//               matchingPrescription?.patient_id ||
//               // matchingPrescription?.appointment?.patient_id ||
//               matchingPrescription.appointment.patient_id._id;
//             // matchingPrescription.appointment.patient_id.patient_id;
//             if (patientId) {
//               fetchVisitCount(patientId);
//             }

//             console.log(
//               "the patientId after mathc found is :",
//               matchingPrescription.appointment.patient_id.patient_id
//             );

//             console.log(
//               "the patientId after mathc found is :",
//               matchingPrescription?.appointment?.patient?.patient_id
//             );
//             console.log(
//               "the patientId after mathc found is :",
//               matchingPrescription?.patient_id
//             );
//             console.log(
//               "the patientId after mathc found is :",
//               matchingPrescription?.appointment?.patient_id
//             );
//             console.log(
//               "the final patientId after mathc found is :",
//               patientId
//             );

//             return;
//           } else {
//             console.log("No matching prescription found in all prescriptions");
//           }
//         }
//       } catch (allPrescriptionsError) {
//         console.log(
//           "Failed to fetch all prescriptions:",
//           allPrescriptionsError.message
//         );
//       }

//       // Try different prescription endpoint patterns
//       const prescriptionEndpoints = [
//         `${Apiurl}/prescriptions/${id}`,
//         `${Apiurl}/prescription/${id}`,
//         `${Apiurl}/prescriptions/details/${id}`,
//         `${Apiurl}/prescription-data/${id}`,
//         `${Apiurl}/prescriptions/single/${id}`,
//       ];

//       let prescriptionData = null;

//       for (const endpoint of prescriptionEndpoints) {
//         try {
//           console.log("Trying endpoint:", endpoint);
//           const response = await axios.get(endpoint);
//           if (response.status === 200 && response.data) {
//             prescriptionData = response.data;
//             console.log(
//               "Successfully fetched prescription data from:",
//               endpoint
//             );
//             console.log("Fetched Prescription Data:", prescriptionData);
//             break;
//           }
//         } catch (endpointError) {
//           console.log(
//             `Failed to fetch from ${endpoint}:`,
//             endpointError.message
//           );
//         }
//       }

//       if (prescriptionData) {
//         setResponseData(prescriptionData);

//         // Fetch visit count based on patient_id
//         const patientId =
//           prescriptionData?.appointment?.patient?.patient_id ||
//           prescriptionData?.patient_id ||
//           prescriptionData?.appointment?.patient_id;
//         if (patientId) {
//           fetchVisitCount(patientId);
//         }
//         return;
//       }

//       // Fallback: try to fetch as appointment data
//       console.log("Trying to fetch as appointment data...");
//       const appointmentEndpoints = [
//         `${Apiurl}/appointments/${id}`,
//         `${Apiurl}/appointment/${id}`,
//       ];

//       for (const endpoint of appointmentEndpoints) {
//         try {
//           console.log("Trying appointment endpoint:", endpoint);
//           const response = await axios.get(endpoint);
//           if (response.status === 200) {
//             const data = Array.isArray(response.data)
//               ? response.data[0]
//               : response.data;
//             if (data) {
//               setResponseData(data);
//               console.log("Fetched Appointment Data:", data);

//               if (data?.patient_id) {
//                 fetchVisitCount(data.patient_id);
//               }
//               return;
//             }
//           }
//         } catch (endpointError) {
//           console.log(
//             `Failed to fetch from ${endpoint}:`,
//             endpointError.message
//           );
//         }
//       }

//       console.error("Failed to fetch data from all endpoints");
//       console.log("Available endpoints to try:");
//       console.log("- Check if your API has a different prescription endpoint");
//       console.log("- Verify the ID format is correct");
//       console.log("- Check if the prescription exists in the database");
//     } catch (error) {
//       console.error("General error in fetchPrescriptionData:", error.message);
//     }
//   };


//     useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   const fetchVisitCount = async (patientId) => {
//     try {
//       let response = await axios.get(
//         `${Apiurl}/appointments?patient_id=${patientId}`
//       );
//       console.log("response data from hospital bill", response);
//       let appointments = response.data || [];

//       // Log API response for debugging
//       console.log(`API Response for patient_id ${patientId}:`, appointments);

//       // If API doesn't filter correctly, fetch all appointments and filter client-side
//       if (!appointments.every((appt) => appt.patient_id === patientId)) {
//         console.warn(
//           "API did not filter by patient_id, fetching all appointments"
//         );
//         response = await axios.get(`${Apiurl}/appointments`);
//         appointments = response.data || [];
//         appointments = appointments.filter(
//           (appt) => appt.patient_id === patientId
//         );
//       }

//       setVisitCount(appointments.length || 0);
//       console.log(`Visit count for patient ${patientId}:`, appointments.length);
//     } catch (error) {
//       console.error("Error fetching visit count:", error.message);
//       setVisitCount(0);
//       console.log(`Fallback visit count for patient ${patientId}: 0`);
//     }
//   };

//   useEffect(() => {
//     fetchPrescriptionData();
//   }, [id, navigate]);

//   // Shows dose type ("Drops"/"Counts") for new records, falling back to
//   // the legacy time value ("HH:MM") or "meal" for older prescriptions.
//   const formatDoseLabel = (slot) => {
//     const value = slot?.dose_type || slot?.time;
//     if (!value || value === "0" || value === "0:00") return "meal";
//     if (value === "drops" || value === "counts") {
//       return value.charAt(0).toUpperCase() + value.slice(1);
//     }
//     return value;
//   };

//   const formatTiming = (timing) => {
//     const times = [];

//     if (timing.fn?.before === "1" || timing.fn?.before === "true") {
//       times.push(`Morning (Before ${formatDoseLabel(timing.fn)})`);
//     }
//     if (timing.fn?.after === "1" || timing.fn?.after === "true") {
//       times.push(`Morning (After ${formatDoseLabel(timing.fn)})`);
//     }

//     if (timing.an?.before === "1" || timing.an?.before === "true") {
//       times.push(`Afternoon (Before ${formatDoseLabel(timing.an)})`);
//     }
//     if (timing.an?.after === "1" || timing.an?.after === "true") {
//       times.push(`Afternoon (After ${formatDoseLabel(timing.an)})`);
//     }

//     if (timing.night?.before === "1" || timing.night?.before === "true") {
//       times.push(`Night (Before ${formatDoseLabel(timing.night)})`);
//     }
//     if (timing.night?.after === "1" || timing.night?.after === "true") {
//       times.push(`Night (After ${formatDoseLabel(timing.night)})`);
//     }

//     return times.join(", ");
//   };

//   // Helper function to safely access patient data
//   const getPatientData = (field) => {

//     // Prioritize prescription_weight for weight_kg
//     if (field === "prescription_weight" && responseData?.prescription_weight) {
//       return responseData?.prescription_weight;
//     }
//     if (responseData?.appointment?.patient) {
//       return responseData.appointment.patient[field];
//     }
//     if (responseData?.patients_details?.[0]) {
//       return responseData.patients_details[0][field];
//     }

//     // this is the new code
//     if (responseData?.appointment?.patient_id) {
//       return responseData?.appointment?.patient_id?.[field];
//     }

//     return null;
//   };


//   // Helper function to safely access doctor data
//   const getDoctorData = (field) => {
//     if (responseData?.appointment?.doctor_id) {
//       return responseData.appointment.doctor_id[field];
//     }
//     if (responseData?.doctor_details?.[0]) {
//       return responseData.doctor_details[0][field];
//     }
//     return null;
//   };

//   // Helper function to safely access prescription data
//   const getPrescriptionData = (field) => {
//     if (
//       responseData?.[field] !== undefined &&
//       responseData?.[field] !== null &&
//       responseData?.[field] !== ""
//     ) {
//       return responseData[field];
//     }
//     if (responseData?.prescription_data_details?.[0]) {
//       return responseData.prescription_data_details[0][field];
//     }
//     if (responseData?.appointment?.prescription_data_details) {
//       return responseData.appointment.prescription_data_details[field];
//     }
//     return null;
//   };

//   const clinicalAssessment =
//     getPrescriptionData("clinical_assessment") || {};
//   const mindAssessment = clinicalAssessment?.mind || {};

//   const formatAssessmentValue = (value) => {
//     if (Array.isArray(value)) {
//       return value.length ? value.join(", ") : "-";
//     }
//     if (value === undefined || value === null || value === "") {
//       return "-";
//     }
//     return String(value);
//   };

//   const assessmentSections = [
//     {
//       title: "Case History",
//       fields: [
//         ["Presenting Complaints", "presenting_complaints"],
//         ["Past History", "past_history"],
//         ["Treatment History", "treatment_history"],
//         ["Family History", "family_history"],
//       ],
//     },
//     {
//       title: "Physical General",
//       fields: [
//         ["Diet", "diet"],
//         ["Appetite", "appetite"],
//         ["Thirst", "thirst"],
//         ["Bowel Habits", "bowel_habits"],
//         ["Urination", "urination"],
//         ["Sleep", "sleep"],
//         ["Dreams", "dreams"],
//         ["Perspiration", "perspiration"],
//         ["Habits / Addictions", "habits_addictions"],
//         ["Thermal", "thermal"],
//         ["Craving", "craving"],
//         ["Aversion", "aversion"],
//         ["Ailments From", "ailments_from"],
//         ["Menstrual History", "menstrual_history"],
//       ],
//     },
//     {
//       title: "Physical Examination",
//       fields: [
//         ["Weight", "weight"],
//         ["Height", "height"],
//         ["BP", "bp"],
//         ["Pulse", "pulse"],
//         ["Temperature", "temperature"],
//       ],
//     },
//     {
//       title: "Systemic Examination",
//       fields: [
//         ["CVS", "cvs"],
//         ["RS", "rs"],
//       ],
//     },
//     {
//       title: "Investigations & Repertorial Totality",
//       fields: [
//         ["Investigations", "investigations"],
//         ["Repertorial Totality", "repertorial_totality"],
//       ],
//     },
//   ];

//   const mindFields = [
//     ["Usual Mood", "usual_mood"],
//     ["Sensitivity to Criticism", "sensitivity_to_criticism"],
//     ["Weeping Tendency", "weeping_tendency"],
//     ["Consolation", "consolation"],
//     ["Memory", "memory"],
//     ["Concentration", "concentration"],
//     ["Mistakes", "mistakes"],
//     ["Cleanliness", "cleanliness"],
//     ["Fastidious", "fastidious"],
//     ["Disturbed if Things Out of Place", "disturbed_if_out_of_place"],
//     ["Perfectionist", "perfectionist"],
//     ["Reaction to Imperfection", "reaction_to_imperfection"],
//     ["High Expectations From Self", "high_expectations_self"],
//     ["High Expectations From Others", "high_expectations_others"],
//     ["Follows Routine Strictly", "follows_routine_strictly"],
//     ["Adaptability to Change", "adaptability_to_change"],
//     ["Time Consciousness", "time_consciousness"],
//     ["Lifestyle Discipline", "lifestyle_discipline"],
//     ["Working Style", "working_style"],
//     ["Multitasking", "multitasking"],
//     ["Physical Energy", "physical_energy"],
//     ["Patience", "patience"],
//     ["Reaction While Waiting", "reaction_while_waiting"],
//     ["Stubbornness", "stubbornness"],
//     ["Changes Opinion Easily", "changes_opinion_easily"],
//     ["Forgives / Holds Grudges", "forgives_or_holds_grudges"],
//     ["Suppresses / Expresses", "suppresses_or_expresses"],
//     ["Overthinks Situations", "overthinks_situations"],
//     ["Nature", "nature"],
//     ["Needs Control", "needs_control"],
//     ["Social Type", "social_type"],
//     ["Comfort With Strangers", "comfort_with_strangers"],
//     ["Adjusts / Needs Space", "adjusts_or_needs_space"],
//     ["Responsibility", "responsibility"],
//     ["Initiative Level", "initiative_level"],
//     ["Satisfaction", "satisfaction"],
//     ["Fears", "fears"],
//     ["Specific Phobias", "specific_phobias"],
//     ["Anxiety About", "anxiety_about"],
//     ["Anxiety Time", "anxiety_time"],
//     ["Anticipatory Anxiety", "anticipatory_anxiety"],
//     ["Anger Triggers", "anger_triggers"],
//     ["Anger Expression", "anger_expression"],
//     ["After Anger", "after_anger"],
//     ["Past Emotional Shocks", "past_emotional_shocks"],
//     ["Effect on Health", "effect_on_health"],
//     ["Sleep Position", "sleep_position"],
//     ["Dream Themes", "dream_themes"],
//     ["Sleep Quality", "sleep_quality"],
//     ["Ambition Level", "ambition_level"],
//     ["Religious / Spiritual Tendency", "religious_spiritual_tendency"],
//     ["Artistic / Creative Interests", "artistic_creative_interests"],
//     ["Peculiar Habits", "peculiar_habits"],
//   ];

//   const renderAssessmentSection = (title, fields, source = clinicalAssessment) => (
//     <div style={{ marginTop: "10px", pageBreakInside: "avoid" }}>
//       <strong style={{ fontSize: "16px" }}>{title}</strong>
//       <div className="row" style={{ fontSize: "13px", marginTop: "4px" }}>
//         {fields.map(([label, key]) => (
//           <div className="col-lg-4 col-md-6 col-12 mb-1" key={key}>
//             <strong>{label}:</strong>{" "}
//             {formatAssessmentValue(source?.[key])}
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   return (
//     <>
//       <div className="d-flex justify-content-between">
//         <div className="mt-2 d-print-none">
//           <button
//             className="btn btn-secondary btn-sm ms-2"
//             onClick={() => navigate("/pharmacy/prescription")}
//           >
//             Back
//           </button>
//         </div>
//         <Container
//           fluid
//           style={{
//             padding: "10px",
//             fontSize: "14px",
//             lineHeight: "1.4",
//             fontFamily: "Arial, sans-serif",
//             width: "100%",
//             maxWidth: "210mm",
//             margin: "0 auto",
//             boxSizing: "border-box",
//             border: "1px solid black",
//           }}
//         >
//           <Row style={{ marginBottom: "15px" }}>
//             <Col
//               xs={6}
//               style={{
//                 flexDirection: "column",
//               }}
//             >
//               <Image
//                 src={logo}
//                 alt="4Health Homeopathy"
//                 style={{ maxWidth: "100px", marginBottom: "5px" }}
//               />
//               <h5 style={{ fontSize: "16px", margin: "5px 0" }}>
//                 4Health Homeopathy
//               </h5>
//             </Col>
//             <Col
//               xs={6}
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 textAlign: "right",
//                 padding: "8px",
//               }}
//             >
//               <h4 style={{ fontSize: "18px", margin: "0" }} className="fw-bold">
//                 {getDoctorData("doctor_name") || "Yoga Instructor"}
//               </h4>
//               <p style={{ fontSize: "14px", margin: "2px 0" }}>
//                 {getDoctorData("qualification") || "Yoga Instructor"}
//               </p>
//               <p style={{ fontSize: "14px", margin: "2px 0" }}>
//                 {getDoctorData("speciality") || "Yoga Instructor"}
//               </p>
//             </Col>
//           </Row>

//           <Row>
//             <Col md={6} style={{ fontSize: "14px", marginBottom: "10px" }}>
//               <p style={{ margin: "2px 0" }}>
//                 <strong>Patient ID:</strong> {getPatientData("patient_id") || "N/A"}
//               </p>
//               <p style={{ margin: "2px 0" }}>
//                 <strong>Patient:</strong>{" "}
//                 {getPatientData("first_name") || "N/A"}{" "}
//                 {getPatientData("last_name") || ""} (
//                 {getPatientData("age") || "N/A"}y,{" "}
//                 {getPatientData("gender") || "N/A"})
//               </p>
//               <p style={{ margin: "2px 0" }}>
//                 <strong>Partner:</strong>{" "}
//                 {getPatientData("spouse_name") || "N/A"}
//               </p>
//             </Col>
//             <Col
//               md={6}
//               style={{
//                 fontSize: "14px",
//                 textAlign: "right",
//                 marginBottom: "10px",
//               }}
//               className="print-right"
//             >
//               <p style={{ margin: "2px 0" }}>
//                 <strong>Date:</strong>{" "}
//                 {responseData?.date ||
//                   responseData?.appointment_date ||
//                   new Date().toLocaleDateString()}
//               </p>
//               <p style={{ margin: "2px 0" }}>
//                 <strong>Next Visit Date:</strong>{" "}
//                 {responseData?.next_visit_date ||
//                   responseData?.prescription_data_details?.[0]
//                     ?.next_visit_date ||
//                   "N/A"}
//               </p>
//               <p style={{ margin: "2px 0" }}>
//                 <strong>Visit:</strong> {visitCount || "N/A"}
//               </p>
//             </Col>
//           </Row>
//           <hr style={{ margin: "10px 0", border: "1px solid #000" }} />

//           <Row>
//             <Col xs={12} style={{ fontSize: "14px", marginBottom: "10px" }}>
//               <p style={{ margin: "2px 0" }}>
//                 <strong>Consultation Vitals:</strong>{" "}
//                 Weight: {getPrescriptionData("prescription_weight") || "-"} |{" "}
//                 BP: {getPrescriptionData("prescription_bp") || "-"} |{" "}
//                 Pulse: {getPrescriptionData("prescription_pulse") || "-"} |{" "}
//                 Temperature: {getPrescriptionData("prescription_temperature") || "-"}
//               </p>
//             </Col>
//           </Row>

//           <div className="row">
//             <div className="col-lg-6 col-md-6">
//               <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
//                 Complaints:
//               </strong>
//               <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
//                 <li style={{ marginBottom: "2px" }}>
//                   {getPatientData("previous_histroy") || "N/A"} - complaint history
//                 </li>
//                 <li style={{ marginBottom: "2px" }}>
//                   {getPatientData("notes") || "No additional notes"}
//                 </li>
//               </ul>
//             </div>

//             <div className="col-lg-6 col-md-6">
//               <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
//                 Siemen Analysis
//               </strong>
//               <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
//                 <li style={{ marginBottom: "2px" }}>
//                   {getPatientData("siemen_analysis") ||
//                     "No siemen analysis data available"}
//                 </li>
//               </ul>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-lg-6 col-md-6">
//               <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
//                 Examination:
//               </strong>
//               <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
//                 <li style={{ marginBottom: "2px" }}>
//                   {getPatientData("per_abutamon") ||
//                     getPatientData("per_speculum") ||
//                     getPatientData("per_virginal_exam") ||
//                     getPatientData("previous_histroy") ||
//                     "No examination data available"}
//                 </li>
//               </ul>
//             </div>

//             <div className="col-lg-6 col-md-6">
//               <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
//                 Diagnosis
//               </strong>
//               <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
//                 <li style={{ marginBottom: "2px" }}>
//                   {getPrescriptionData("diagnosis") ||
//                     "No diagnosis data available"}
//                 </li>
//               </ul>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-lg-6 col-md-6">
//               <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
//                 Investigations / Reports
//               </strong>
//               <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
//                 <li style={{ marginBottom: "2px" }}>
//                   {getPrescriptionData("scan_findings") ||
//                     "No investigation data available"}
//                 </li>
//               </ul>
//             </div>

//             <div className="col-lg-6 col-md-6">
//               <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
//                 Treatment Plan:
//               </strong>
//               <p style={{ fontSize: "14px", margin: "2px 0" }}>
//                 {getPrescriptionData("plan_of_treatment") ||
//                   getPatientData("plan_of_treatment") ||
//                   "No treatment plan available"}
//               </p>
//             </div>
//           </div>

//           {/* ===== Current Clinical Assessment ===== */}
//           <div
//             style={{
//               marginTop: "12px",
//               paddingTop: "8px",
//               borderTop: "1px solid #000",
//             }}
//           >
//             <h5 style={{ fontSize: "18px", margin: "0 0 6px" }}>
//               Clinical Assessment
//             </h5>
//             {assessmentSections.slice(0, 1).map((section) => (
//               <React.Fragment key={section.title}>
//                 {renderAssessmentSection(section.title, section.fields)}
//               </React.Fragment>
//             ))}

//             {/* ===== Case Study ===== */}
//             {formatAssessmentValue(clinicalAssessment?.case_study) !== "-" && (
//               <div
//                 style={{
//                   marginTop: "10px",
//                   marginBottom: "10px",
//                   padding: "10px",
//                   border: "1px solid #ddd",
//                   borderRadius: "6px",
//                 }}
//               >
//                 <strong style={{ fontSize: "15px" }}>Case Study</strong>
//                 <div
//                   style={{
//                     marginTop: "6px",
//                     fontSize: "14px",
//                     whiteSpace: "pre-wrap",
//                     wordBreak: "break-word",
//                   }}
//                 >
//                   {clinicalAssessment.case_study}
//                 </div>
//               </div>
//             )}

//             {assessmentSections.slice(1, 2).map((section) => (
//               <React.Fragment key={section.title}>
//                 {renderAssessmentSection(section.title, section.fields)}
//               </React.Fragment>
//             ))}

//             {renderAssessmentSection("Mind", mindFields, mindAssessment)}

//             {assessmentSections.slice(2).map((section) => (
//               <React.Fragment key={section.title}>
//                 {renderAssessmentSection(section.title, section.fields)}
//               </React.Fragment>
//             ))}
//           </div>

//           <Row style={{ marginTop: "15px" }}>
//             <Col xs={12}>
//               <strong
//                 style={{
//                   fontSize: "20px",
//                   marginBottom: "18px",
//                 }}
//               >
//                 Medication Protocol
//               </strong>
//               <Table
//                 bordered
//                 responsive
//                 style={{
//                   fontSize: "14px",
//                   width: "100%",
//                   borderCollapse: "collapse",
//                 }}
//               >
//                 <thead>
//                   <tr>
//                     <th style={{ padding: "5px", border: "1px solid #000" }}>
//                       Medication
//                     </th>
//                     <th style={{ padding: "5px", border: "1px solid #000" }}>
//                       Dosage
//                     </th>
//                     <th style={{ padding: "5px", border: "1px solid #000" }}>
//                       Timing - Duration
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {responseData?.medicines?.length
//                     ? responseData.medicines.map((medicine, index) => (
//                       <tr key={index}>
//                         <td
//                           style={{
//                             padding: "5px",
//                             border: "1px solid #000",
//                           }}
//                         >
//                           {index + 1}){" "}
//                           <strong>{medicine.medicine_name}</strong>
//                           <br />
//                           <small style={{ fontSize: "12px" }}>
//                             Composition: {medicine.medicine_name}
//                           </small>
//                         </td>
//                         <td
//                           style={{
//                             padding: "5px",
//                             border: "1px solid #000",
//                           }}
//                         >
//                           {medicine.dosage}
//                         </td>
//                         <td
//                           style={{
//                             padding: "5px",
//                             border: "1px solid #000",
//                           }}
//                         >
//                           {formatTiming(medicine.timing)} -{" "}
//                           {medicine.duration}
//                         </td>
//                       </tr>
//                     ))
//                     : responseData?.prescription_data_details?.flatMap(
//                       (prescription, prescriptionIndex) =>
//                         prescription.medicines?.length
//                           ? prescription.medicines.map((medicine, index) => (
//                             <tr key={`${prescription._id}-${index}`}>
//                               <td
//                                 style={{
//                                   padding: "5px",
//                                   border: "1px solid #000",
//                                 }}
//                               >
//                                 {index + 1}){" "}
//                                 <strong>{medicine.medicine_name}</strong>
//                                 <br />
//                                 <small style={{ fontSize: "12px" }}>
//                                   Composition: {medicine.medicine_name}
//                                 </small>
//                               </td>
//                               <td
//                                 style={{
//                                   padding: "5px",
//                                   border: "1px solid #000",
//                                 }}
//                               >
//                                 {medicine.dosage}
//                               </td>
//                               <td
//                                 style={{
//                                   padding: "5px",
//                                   border: "1px solid #000",
//                                 }}
//                               >
//                                 {formatTiming(medicine.timing)} -{" "}
//                                 {medicine.duration}
//                               </td>
//                             </tr>
//                           ))
//                           : prescription.medicine_name
//                             ? [
//                               <tr
//                                 key={`${prescription._id}-${prescriptionIndex}`}
//                               >
//                                 <td
//                                   style={{
//                                     padding: "5px",
//                                     border: "1px solid #000",
//                                   }}
//                                 >
//                                   {prescriptionIndex + 1}){" "}
//                                   <strong>
//                                     {prescription.medicine_name}
//                                   </strong>
//                                   <br />
//                                   <small style={{ fontSize: "12px" }}>
//                                     Composition: {prescription.medicine_name}
//                                   </small>
//                                 </td>
//                                 <td
//                                   style={{
//                                     padding: "5px",
//                                     border: "1px solid #000",
//                                   }}
//                                 >
//                                   {prescription.dosage}
//                                 </td>
//                                 <td
//                                   style={{
//                                     padding: "5px",
//                                     border: "1px solid #000",
//                                   }}
//                                 >
//                                   {formatTiming(prescription.timing)} -{" "}
//                                   {prescription.duration}
//                                 </td>
//                               </tr>,
//                             ]
//                             : []
//                     ) || [
//                       <tr key="no-medicines">
//                         <td
//                           colSpan="3"
//                           style={{
//                             padding: "5px",
//                             border: "1px solid #000",
//                             textAlign: "center",
//                           }}
//                         >
//                           No medications prescribed
//                         </td>
//                       </tr>,
//                     ]}
//                 </tbody>
//               </Table>
//             </Col>
//           </Row>

//           <Row>
//             <Col xs={12}>
//               <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
//                 Advice
//               </strong>
//               <p style={{ fontSize: "14px", margin: "2px 0" }}>
//                 {getPrescriptionData("advise") ||
//                   getPatientData("advise") ||
//                   "No advice available"}
//               </p>
//             </Col>
//           </Row>

//           <Row>
//             <Col xs={12}>
//               <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
//                 Monitoring Schedule:
//               </strong>
//               <ul style={{ fontSize: "14px", paddingLeft: "20px" }}>
//                 <li>Baseline scan as per menstrual cycle</li>
//                 <li>Follicular monitoring as advised</li>
//                 <li>Repeat scan as advised</li>
//               </ul>
//             </Col>
//           </Row>

//           <Row>
//             <Col xs={12}>
//               <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
//                 Instructions:
//               </strong>
//               <ul style={{ fontSize: "14px", paddingLeft: "20px" }}>
//                 <li>
//                   {getPrescriptionData("instructions") ||
//                     "Follow up as advised"}
//                 </li>
//                 <li>Maintain healthy diet and moderate exercise</li>
//               </ul>
//             </Col>
//             <Col
//               xs={12}
//               style={{
//                 textAlign: "right",
//                 fontWeight: "bold",
//                 fontSize: "14px",
//                 paddingTop: "60px",
//               }}
//             >
//               <p style={{ margin: "10px 0" }}>
//                 {getDoctorData("doctor_name") || "Yoga Instructor"},
//                 {getDoctorData("qualification")}
//               </p>
//             </Col>
//           </Row>

//           <hr style={{ margin: "10px 0", border: "1px solid #000" }} />

//           <Row>
//             <Col xs={12} style={{ textAlign: "center", fontSize: "12px" }}>
//               <p style={{ color: "#000", margin: "2px 0" }}>
//                 <i className="fa-solid fa-phone"></i>{" "}
//                 {getDoctorData("mobile_no") || "+91 99448 44408"} |{" "}
//                 <i className="fa-regular fa-envelope"></i>{" "}
//                 {getDoctorData("email") || "info@4healthhomeopathy.com"}
//               </p>
//               <div style={{ color: "#000000", margin: "2px 0" }}>
//                 Developed By Aalantechsoft-Salem
//               </div>
//             </Col>
//           </Row>
//         </Container>
//         <div className="mt-2 d-print-none">
//           <button className="btn btn-primary btn-sm me-2" onClick={handlePrint}>
//             Print
//           </button>
//         </div>
//       </div>
//       <style>
//         {`
//           @media print {
//             .print-right {
//               text-align: right !important;
//             }
//             body {
//               margin: 0;
//               padding: 0;
//               font-size: 12px;
//               margin-top: 20px !important;
//             }
//             .container-fluid {
//               width: 100%;
//               max-width: 210mm;
//               padding: 5mm;
//               margin: 0;
//               box-sizing: border-box;
//             }
//             h2 {
//               font-size: 18px !important;
//               margin-bottom: 8px !important;
//             }
//             h4, h5 {
//               font-size: 14px !important;
//               margin: 5px 0 !important;
//             }
//             p, li, td, th, small {
//               font-size: 12px !important;
//               line-height: 1.3 !important;
//               margin-bottom: 3px !important;
//             }
//             img {
//               max-width: 80px !important;
//             }
//             hr {
//               margin: 8px 0 !important;
//               border: 1px solid #000 !important;
//             }
//             table {
//               width: 100% !important;
//               margin-bottom: 8px !important;
//               border-collapse: collapse !important;
//             }
//             th, td {
//               padding: 3px !important;
//               border: 1px solid #000 !important;
//             }
//             @page {
//               size: A4;
//               margin: 5mm;
//             }
//           }
//         `}
//       </style>
//     </>
//   );
// };

// export default Prescriptionbill;




import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Table } from "react-bootstrap";

import logo from "../../../../assets/images/Logo.png";
import axios from "axios";
import Apiurl from "../../../environment/Apiurl";
import { useParams, useNavigate } from "react-router-dom";

const Prescriptionbill = () => {
  const handlePrint = () => {
    window.print();
  };
  const { id } = useParams();
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState(null);
  const [visitCount, setVisitCount] = useState(0);

  // Fetch prescription or appointment data
  const fetchPrescriptionData = async () => {
    try {
      console.log("Fetching data for ID:", id);
      console.log("ID type:", typeof id);
      console.log("ID length:", id?.length);

      // First, try to get all prescriptions and find the matching one
      try {
        console.log("Trying to fetch all prescriptions and filter...");
        const allPrescriptionsResponse = await axios.get(
          `${Apiurl}/prescriptions`
        );
        if (
          allPrescriptionsResponse.status === 200 &&
          Array.isArray(allPrescriptionsResponse.data)
        ) {
          const matchingPrescription = allPrescriptionsResponse.data.find(
            (prescription) => prescription._id === id || prescription.id === id
          );

          if (matchingPrescription) {
            console.log("Found matching prescription:", matchingPrescription);
            setResponseData(matchingPrescription);

            // Fetch visit count based on patient_id
            const patientId =
              matchingPrescription?.appointment?.patient?.patient_id ||
              matchingPrescription?.patient_id ||
              // matchingPrescription?.appointment?.patient_id ||
              matchingPrescription.appointment.patient_id._id;
            // matchingPrescription.appointment.patient_id.patient_id;
            if (patientId) {
              fetchVisitCount(patientId);
            }

            console.log(
              "the patientId after mathc found is :",
              matchingPrescription.appointment.patient_id.patient_id
            );

            console.log(
              "the patientId after mathc found is :",
              matchingPrescription?.appointment?.patient?.patient_id
            );
            console.log(
              "the patientId after mathc found is :",
              matchingPrescription?.patient_id
            );
            console.log(
              "the patientId after mathc found is :",
              matchingPrescription?.appointment?.patient_id
            );
            console.log(
              "the final patientId after mathc found is :",
              patientId
            );

            return;
          } else {
            console.log("No matching prescription found in all prescriptions");
          }
        }
      } catch (allPrescriptionsError) {
        console.log(
          "Failed to fetch all prescriptions:",
          allPrescriptionsError.message
        );
      }

      // Try different prescription endpoint patterns
      const prescriptionEndpoints = [
        `${Apiurl}/prescriptions/${id}`,
        `${Apiurl}/prescription/${id}`,
        `${Apiurl}/prescriptions/details/${id}`,
        `${Apiurl}/prescription-data/${id}`,
        `${Apiurl}/prescriptions/single/${id}`,
      ];

      let prescriptionData = null;

      for (const endpoint of prescriptionEndpoints) {
        try {
          console.log("Trying endpoint:", endpoint);
          const response = await axios.get(endpoint);
          if (response.status === 200 && response.data) {
            prescriptionData = response.data;
            console.log(
              "Successfully fetched prescription data from:",
              endpoint
            );
            console.log("Fetched Prescription Data:", prescriptionData);
            break;
          }
        } catch (endpointError) {
          console.log(
            `Failed to fetch from ${endpoint}:`,
            endpointError.message
          );
        }
      }

      if (prescriptionData) {
        setResponseData(prescriptionData);

        // Fetch visit count based on patient_id
        const patientId =
          prescriptionData?.appointment?.patient?.patient_id ||
          prescriptionData?.patient_id ||
          prescriptionData?.appointment?.patient_id;
        if (patientId) {
          fetchVisitCount(patientId);
        }
        return;
      }

      // Fallback: try to fetch as appointment data
      console.log("Trying to fetch as appointment data...");
      const appointmentEndpoints = [
        `${Apiurl}/appointments/${id}`,
        `${Apiurl}/appointment/${id}`,
      ];

      for (const endpoint of appointmentEndpoints) {
        try {
          console.log("Trying appointment endpoint:", endpoint);
          const response = await axios.get(endpoint);
          if (response.status === 200) {
            const data = Array.isArray(response.data)
              ? response.data[0]
              : response.data;
            if (data) {
              setResponseData(data);
              console.log("Fetched Appointment Data:", data);

              if (data?.patient_id) {
                fetchVisitCount(data.patient_id);
              }
              return;
            }
          }
        } catch (endpointError) {
          console.log(
            `Failed to fetch from ${endpoint}:`,
            endpointError.message
          );
        }
      }

      console.error("Failed to fetch data from all endpoints");
      console.log("Available endpoints to try:");
      console.log("- Check if your API has a different prescription endpoint");
      console.log("- Verify the ID format is correct");
      console.log("- Check if the prescription exists in the database");
    } catch (error) {
      console.error("General error in fetchPrescriptionData:", error.message);
    }
  };


    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const fetchVisitCount = async (patientId) => {
    try {
      let response = await axios.get(
        `${Apiurl}/appointments?patient_id=${patientId}`
      );
      console.log("response data from hospital bill", response);
      let appointments = response.data || [];

      // Log API response for debugging
      console.log(`API Response for patient_id ${patientId}:`, appointments);

      // If API doesn't filter correctly, fetch all appointments and filter client-side
      if (!appointments.every((appt) => appt.patient_id === patientId)) {
        console.warn(
          "API did not filter by patient_id, fetching all appointments"
        );
        response = await axios.get(`${Apiurl}/appointments`);
        appointments = response.data || [];
        appointments = appointments.filter(
          (appt) => appt.patient_id === patientId
        );
      }

      setVisitCount(appointments.length || 0);
      console.log(`Visit count for patient ${patientId}:`, appointments.length);
    } catch (error) {
      console.error("Error fetching visit count:", error.message);
      setVisitCount(0);
      console.log(`Fallback visit count for patient ${patientId}: 0`);
    }
  };

  useEffect(() => {
    fetchPrescriptionData();
  }, [id, navigate]);

  // ===================== DISPLAY HELPERS =====================

  const isFilled = (value) => {
    if (value === null || value === undefined) return false;

    if (Array.isArray(value)) {
      return value.some((item) => isFilled(item));
    }

    if (typeof value === "object") {
      return Object.values(value).some((item) => isFilled(item));
    }

    if (typeof value === "string") {
      return value.trim() !== "";
    }

    return true;
  };

  // Helper function to safely access patient data
  const getPatientData = (field) => {
    if (field === "prescription_weight" && responseData?.prescription_weight) {
      return responseData.prescription_weight;
    }

    if (responseData?.appointment?.patient) {
      return responseData.appointment.patient[field];
    }

    if (responseData?.patients_details?.[0]) {
      return responseData.patients_details[0][field];
    }

    if (responseData?.appointment?.patient_id) {
      return responseData.appointment.patient_id[field];
    }

    return null;
  };

  // Helper function to safely access doctor data
  const getDoctorData = (field) => {
    if (responseData?.appointment?.doctor_id) {
      return responseData.appointment.doctor_id[field];
    }

    if (responseData?.doctor_details?.[0]) {
      return responseData.doctor_details[0][field];
    }

    return null;
  };

  // Helper function to safely access prescription data
  const getPrescriptionData = (field) => {
    if (
      responseData?.[field] !== undefined &&
      responseData?.[field] !== null &&
      responseData?.[field] !== ""
    ) {
      return responseData[field];
    }

    if (responseData?.prescription_data_details?.[0]) {
      return responseData.prescription_data_details[0][field];
    }

    if (responseData?.appointment?.prescription_data_details) {
      return responseData.appointment.prescription_data_details[field];
    }

    return null;
  };

  const getMedicines = () => {
    if (Array.isArray(responseData?.medicines) && responseData.medicines.length) {
      return responseData.medicines;
    }

    if (Array.isArray(responseData?.prescription_data_details)) {
      return responseData.prescription_data_details.flatMap((prescription) => {
        if (Array.isArray(prescription?.medicines)) {
          return prescription.medicines;
        }

        if (prescription?.medicine_name) {
          return [prescription];
        }

        return [];
      });
    }

    if (
      Array.isArray(responseData?.appointment?.prescription_data_details?.medicines)
    ) {
      return responseData.appointment.prescription_data_details.medicines;
    }

    return [];
  };

  const medicines = getMedicines();

  const clinicalAssessment =
    getPrescriptionData("clinical_assessment") || {};

  const mindAssessment = clinicalAssessment?.mind || {};

  const formatAssessmentValue = (value) => {
    if (Array.isArray(value)) {
      return value.filter((item) => isFilled(item)).join(", ");
    }

    if (!isFilled(value)) {
      return "";
    }

    return String(value);
  };

  const assessmentSections = [
    {
      title: "Case History",
      fields: [
        ["Presenting Complaints", "presenting_complaints"],
        ["Past History", "past_history"],
        ["Treatment History", "treatment_history"],
        ["Family History", "family_history"],
      ],
    },
    {
      title: "Physical General",
      fields: [
        ["Diet", "diet"],
        ["Appetite", "appetite"],
        ["Thirst", "thirst"],
        ["Bowel Habits", "bowel_habits"],
        ["Urination", "urination"],
        ["Sleep", "sleep"],
        ["Dreams", "dreams"],
        ["Perspiration", "perspiration"],
        ["Habits / Addictions", "habits_addictions"],
        ["Thermal", "thermal"],
        ["Craving", "craving"],
        ["Aversion", "aversion"],
        ["Ailments From", "ailments_from"],
        ["Menstrual History", "menstrual_history"],
      ],
    },
    {
      title: "Physical Examination",
      fields: [
        ["Weight", "weight"],
        ["Height", "height"],
        ["BP", "bp"],
        ["Pulse", "pulse"],
        ["Temperature", "temperature"],
      ],
    },
    {
      title: "Systemic Examination",
      fields: [
        ["CVS", "cvs"],
        ["RS", "rs"],
      ],
    },
    {
      title: "Investigations & Repertorial Totality",
      fields: [
        ["Investigations", "investigations"],
        ["Repertorial Totality", "repertorial_totality"],
      ],
    },
  ];

  const mindFields = [
    ["Usual Mood", "usual_mood"],
    ["Sensitivity to Criticism", "sensitivity_to_criticism"],
    ["Weeping Tendency", "weeping_tendency"],
    ["Consolation", "consolation"],
    ["Memory", "memory"],
    ["Concentration", "concentration"],
    ["Mistakes", "mistakes"],
    ["Cleanliness", "cleanliness"],
    ["Fastidious", "fastidious"],
    ["Disturbed if Things Out of Place", "disturbed_if_out_of_place"],
    ["Perfectionist", "perfectionist"],
    ["Reaction to Imperfection", "reaction_to_imperfection"],
    ["High Expectations From Self", "high_expectations_self"],
    ["High Expectations From Others", "high_expectations_others"],
    ["Follows Routine Strictly", "follows_routine_strictly"],
    ["Adaptability to Change", "adaptability_to_change"],
    ["Time Consciousness", "time_consciousness"],
    ["Lifestyle Discipline", "lifestyle_discipline"],
    ["Working Style", "working_style"],
    ["Multitasking", "multitasking"],
    ["Physical Energy", "physical_energy"],
    ["Patience", "patience"],
    ["Reaction While Waiting", "reaction_while_waiting"],
    ["Stubbornness", "stubbornness"],
    ["Changes Opinion Easily", "changes_opinion_easily"],
    ["Forgives / Holds Grudges", "forgives_or_holds_grudges"],
    ["Suppresses / Expresses", "suppresses_or_expresses"],
    ["Overthinks Situations", "overthinks_situations"],
    ["Nature", "nature"],
    ["Needs Control", "needs_control"],
    ["Social Type", "social_type"],
    ["Comfort With Strangers", "comfort_with_strangers"],
    ["Adjusts / Needs Space", "adjusts_or_needs_space"],
    ["Responsibility", "responsibility"],
    ["Initiative Level", "initiative_level"],
    ["Satisfaction", "satisfaction"],
    ["Fears", "fears"],
    ["Specific Phobias", "specific_phobias"],
    ["Anxiety About", "anxiety_about"],
    ["Anxiety Time", "anxiety_time"],
    ["Anticipatory Anxiety", "anticipatory_anxiety"],
    ["Anger Triggers", "anger_triggers"],
    ["Anger Expression", "anger_expression"],
    ["After Anger", "after_anger"],
    ["Past Emotional Shocks", "past_emotional_shocks"],
    ["Effect on Health", "effect_on_health"],
    ["Sleep Position", "sleep_position"],
    ["Dream Themes", "dream_themes"],
    ["Sleep Quality", "sleep_quality"],
    ["Ambition Level", "ambition_level"],
    ["Religious / Spiritual Tendency", "religious_spiritual_tendency"],
    ["Artistic / Creative Interests", "artistic_creative_interests"],
    ["Peculiar Habits", "peculiar_habits"],
  ];

  const getFilledFields = (fields, source) =>
    fields.filter(([, key]) => isFilled(source?.[key]));

  const renderAssessmentSection = (
    title,
    fields,
    source = clinicalAssessment,
  ) => {
    const filledFields = getFilledFields(fields, source);

    if (!filledFields.length) {
      return null;
    }

    return (
      <div style={{ marginTop: "10px", pageBreakInside: "avoid" }}>
        <strong style={{ fontSize: "16px" }}>{title}</strong>

        <div className="row" style={{ fontSize: "13px", marginTop: "4px" }}>
          {filledFields.map(([label, key]) => (
            <div className="col-lg-4 col-md-6 col-12 mb-1" key={key}>
              <strong>{label}:</strong>{" "}
              {formatAssessmentValue(source?.[key])}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const hasClinicalAssessment =
    assessmentSections.some((section) =>
      getFilledFields(section.fields, clinicalAssessment).length > 0,
    ) ||
    isFilled(clinicalAssessment?.case_study) ||
    getFilledFields(mindFields, mindAssessment).length > 0;

  const formatTiming = (timing = {}) => {
    const result = [];

    const slots = [
      ["FN", timing?.fn],
      ["AN", timing?.an],
      ["NIGHT", timing?.night],
    ];

    slots.forEach(([label, slot]) => {
      const meal = [];

      if (slot?.before === "1" || slot?.before === true || slot?.before === "true") {
        meal.push("BF");
      }

      if (slot?.after === "1" || slot?.after === true || slot?.after === "true") {
        meal.push("AF");
      }

      if (meal.length) {
        result.push(`${label}: ${meal.join("/")}`);
      }
    });

    return result.join(", ");
  };

  const getIntakeType = (medicine) => {
    const doseType =
      medicine?.dose_type ||
      medicine?.timing?.fn?.dose_type ||
      medicine?.timing?.an?.dose_type ||
      medicine?.timing?.night?.dose_type ||
      "";

    const formattedDoseType = doseType
      ? doseType.charAt(0).toUpperCase() + doseType.slice(1)
      : "";

    let administration = "";

    if (medicine?.direct) {
      administration = "Direct";
    } else if (medicine?.water) {
      administration = "With Water";
    }

    return [formattedDoseType, administration].filter(Boolean).join(" - ");
  };

  const showPriceColumn = medicines.some(
    (medicine) => Number(medicine?.price || 0) > 0,
  );

  const showDurationColumn = medicines.some((medicine) =>
    isFilled(medicine?.duration),
  );

  const showTimingColumn = medicines.some((medicine) =>
    isFilled(formatTiming(medicine?.timing)),
  );

  const showIntakeTypeColumn = medicines.some((medicine) =>
    isFilled(getIntakeType(medicine)),
  );

  const showSosColumn = medicines.some((medicine) => medicine?.sos === true);

  const prescriptionVitals = [
    ["Weight", getPrescriptionData("prescription_weight")],
    ["BP", getPrescriptionData("prescription_bp")],
    ["Pulse", getPrescriptionData("prescription_pulse")],
    ["Temperature", getPrescriptionData("prescription_temperature")],
  ].filter(([, value]) => isFilled(value));

  const nextVisitDate = getPrescriptionData("next_visit_date");
  const instructions = getPrescriptionData("instructions");

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="mt-2 d-print-none">
          <button
            className="btn btn-secondary btn-sm ms-2"
            onClick={() => navigate("/pharmacy/prescription")}
          >
            Back
          </button>
        </div>

        <Container
          fluid
          style={{
            padding: "10px",
            fontSize: "14px",
            lineHeight: "1.4",
            fontFamily: "Arial, sans-serif",
            width: "100%",
            maxWidth: "210mm",
            margin: "0 auto",
            boxSizing: "border-box",
            border: "1px solid black",
          }}
        >
          {/* ===================== HEADER ===================== */}
          <Row style={{ marginBottom: "15px" }}>
            <Col xs={6} style={{ flexDirection: "column" }}>
              <Image
                src={logo}
                alt="4Health Homeopathy"
                style={{ maxWidth: "100px", marginBottom: "5px" }}
              />

              <h5 style={{ fontSize: "16px", margin: "5px 0" }}>
                4Health Homeopathy
              </h5>
            </Col>

            <Col
              xs={6}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "right",
                padding: "8px",
              }}
            >
              {isFilled(getDoctorData("doctor_name")) && (
                <h4
                  style={{ fontSize: "18px", margin: "0" }}
                  className="fw-bold"
                >
                  {getDoctorData("doctor_name")}
                </h4>
              )}

              {isFilled(getDoctorData("qualification")) && (
                <p style={{ fontSize: "14px", margin: "2px 0" }}>
                  {getDoctorData("qualification")}
                </p>
              )}

              {isFilled(getDoctorData("speciality")) && (
                <p style={{ fontSize: "14px", margin: "2px 0" }}>
                  {getDoctorData("speciality")}
                </p>
              )}
            </Col>
          </Row>

          {/* ===================== PATIENT / VISIT DETAILS ===================== */}
          <Row>
            <Col md={6} style={{ fontSize: "14px", marginBottom: "10px" }}>
              {isFilled(getPatientData("patient_id")) && (
                <p style={{ margin: "2px 0" }}>
                  <strong>Patient ID:</strong> {getPatientData("patient_id")}
                </p>
              )}

              {(isFilled(getPatientData("first_name")) ||
                isFilled(getPatientData("last_name"))) && (
                <p style={{ margin: "2px 0" }}>
                  <strong>Patient:</strong>{" "}
                  {[getPatientData("first_name"), getPatientData("last_name")]
                    .filter(Boolean)
                    .join(" ")}

                  {(isFilled(getPatientData("age")) ||
                    isFilled(getPatientData("gender"))) && (
                    <>
                      {" "}
                      (
                      {[getPatientData("age") && `${getPatientData("age")}y`,
                        getPatientData("gender")]
                        .filter(Boolean)
                        .join(", ")}
                      )
                    </>
                  )}
                </p>
              )}
            </Col>

            <Col
              md={6}
              style={{
                fontSize: "14px",
                textAlign: "right",
                marginBottom: "10px",
              }}
              className="print-right"
            >
              {isFilled(responseData?.date || responseData?.appointment_date) && (
                <p style={{ margin: "2px 0" }}>
                  <strong>Date:</strong>{" "}
                  {responseData?.date || responseData?.appointment_date}
                </p>
              )}

              {isFilled(nextVisitDate) && (
                <p style={{ margin: "2px 0" }}>
                  <strong>Next Visit Date:</strong> {nextVisitDate}
                </p>
              )}
            </Col>
          </Row>

          <hr style={{ margin: "10px 0", border: "1px solid #000" }} />

          {/* ===================== CONSULTATION VITALS ===================== */}
          {prescriptionVitals.length > 0 && (
            <Row>
              <Col xs={12} style={{ fontSize: "14px", marginBottom: "10px" }}>
                <p style={{ margin: "2px 0" }}>
                  <strong>Consultation Vitals:</strong>{" "}
                  {prescriptionVitals
                    .map(([label, value]) => `${label}: ${value}`)
                    .join(" | ")}
                </p>
              </Col>
            </Row>
          )}

          {/* ===================== CLINICAL ASSESSMENT ===================== */}
          {hasClinicalAssessment && (
            <div
              style={{
                marginTop: "12px",
                paddingTop: "8px",
                borderTop: "1px solid #000",
              }}
            >
              <h5 style={{ fontSize: "18px", margin: "0 0 6px" }}>
                Clinical Assessment
              </h5>

              {renderAssessmentSection(
                assessmentSections[0].title,
                assessmentSections[0].fields,
              )}

              {isFilled(clinicalAssessment?.case_study) && (
                <div
                  style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                  }}
                >
                  <strong style={{ fontSize: "15px" }}>Case Study</strong>

                  <div
                    style={{
                      marginTop: "6px",
                      fontSize: "14px",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {clinicalAssessment.case_study}
                  </div>
                </div>
              )}

              {renderAssessmentSection(
                assessmentSections[1].title,
                assessmentSections[1].fields,
              )}

              {renderAssessmentSection("Mind", mindFields, mindAssessment)}

              {assessmentSections.slice(2).map((section) => (
                <React.Fragment key={section.title}>
                  {renderAssessmentSection(
                    section.title,
                    section.fields,
                    clinicalAssessment,
                  )}
                </React.Fragment>
              ))}
            </div>
          )}

          {/* ===================== MEDICINES ===================== */}
          {medicines.length > 0 && (
            <Row style={{ marginTop: "15px" }}>
              <Col xs={12}>
                <strong
                  style={{
                    fontSize: "20px",
                    marginBottom: "18px",
                  }}
                >
                  Medication
                </strong>

                <Table
                  bordered
                  responsive
                  style={{
                    fontSize: "14px",
                    width: "100%",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ padding: "5px", border: "1px solid #000" }}>
                        Medicine
                      </th>

                      {showPriceColumn && (
                        <th style={{ padding: "5px", border: "1px solid #000" }}>
                          Price
                        </th>
                      )}

                      {showDurationColumn && (
                        <th style={{ padding: "5px", border: "1px solid #000" }}>
                          Duration / Instruction
                        </th>
                      )}

                      {showIntakeTypeColumn && (
                        <th style={{ padding: "5px", border: "1px solid #000" }}>
                          Intake Type
                        </th>
                      )}

                      {showTimingColumn && (
                        <th style={{ padding: "5px", border: "1px solid #000" }}>
                          FN / AN / NIGHT
                        </th>
                      )}

                      {showSosColumn && (
                        <th style={{ padding: "5px", border: "1px solid #000" }}>
                          SOS
                        </th>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {medicines.map((medicine, index) => (
                      <tr key={medicine?._id || index}>
                        <td
                          style={{
                            padding: "5px",
                            border: "1px solid #000",
                          }}
                        >
                          {index + 1}){" "}
                          <strong>{medicine?.medicine_name || ""}</strong>
                        </td>

                        {showPriceColumn && (
                          <td
                            style={{
                              padding: "5px",
                              border: "1px solid #000",
                            }}
                          >
                            {Number(medicine?.price || 0) > 0
                              ? `₹${medicine.price}`
                              : ""}
                          </td>
                        )}

                        {showDurationColumn && (
                          <td
                            style={{
                              padding: "5px",
                              border: "1px solid #000",
                            }}
                          >
                            {isFilled(medicine?.duration)
                              ? medicine.duration
                              : ""}
                          </td>
                        )}

                        {showIntakeTypeColumn && (
                          <td
                            style={{
                              padding: "5px",
                              border: "1px solid #000",
                            }}
                          >
                            {getIntakeType(medicine)}
                          </td>
                        )}

                        {showTimingColumn && (
                          <td
                            style={{
                              padding: "5px",
                              border: "1px solid #000",
                            }}
                          >
                            {formatTiming(medicine?.timing)}
                          </td>
                        )}

                        {showSosColumn && (
                          <td
                            style={{
                              padding: "5px",
                              border: "1px solid #000",
                              textAlign: "center",
                            }}
                          >
                            {medicine?.sos ? "Yes" : ""}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          )}

          {/* ===================== INSTRUCTIONS ===================== */}
          {isFilled(instructions) && (
            <Row>
              <Col xs={12}>
                <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                  Instructions:
                </strong>

                <div
                  style={{
                    fontSize: "14px",
                    margin: "4px 0",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {instructions}
                </div>
              </Col>
            </Row>
          )}

          {/* ===================== DOCTOR SIGNATURE ===================== */}
          {(isFilled(getDoctorData("doctor_name")) ||
            isFilled(getDoctorData("qualification"))) && (
            <Row>
              <Col
                xs={12}
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  fontSize: "14px",
                  paddingTop: "60px",
                }}
              >
                <p style={{ margin: "10px 0" }}>
                  {[getDoctorData("doctor_name"), getDoctorData("qualification")]
                    .filter((value) => isFilled(value))
                    .join(", ")}
                </p>
              </Col>
            </Row>
          )}

          <hr style={{ margin: "10px 0", border: "1px solid #000" }} />

          {/* ===================== FOOTER ===================== */}
          <Row>
            <Col xs={12} style={{ textAlign: "center", fontSize: "12px" }}>
              {(isFilled(getDoctorData("mobile_no")) ||
                isFilled(getDoctorData("email"))) && (
                <p style={{ color: "#000", margin: "2px 0" }}>
                  {isFilled(getDoctorData("mobile_no")) && (
                    <>
                      <i className="fa-solid fa-phone"></i>{" "}
                      {getDoctorData("mobile_no")}
                    </>
                  )}

                  {isFilled(getDoctorData("mobile_no")) &&
                    isFilled(getDoctorData("email")) &&
                    " | "}

                  {isFilled(getDoctorData("email")) && (
                    <>
                      <i className="fa-regular fa-envelope"></i>{" "}
                      {getDoctorData("email")}
                    </>
                  )}
                </p>
              )}

              <div style={{ color: "#000000", margin: "2px 0" }}>
                Developed By Aalantechsoft-Salem
              </div>
            </Col>
          </Row>
        </Container>

        <div className="mt-2 d-print-none">
          <button className="btn btn-primary btn-sm me-2" onClick={handlePrint}>
            Print
          </button>
        </div>
      </div>

      <style>
        {`
          @media print {
            .print-right {
              text-align: right !important;
            }

            body {
              margin: 0;
              padding: 0;
              font-size: 12px;
              margin-top: 20px !important;
            }

            .container-fluid {
              width: 100%;
              max-width: 210mm;
              padding: 5mm;
              margin: 0;
              box-sizing: border-box;
            }

            h2 {
              font-size: 18px !important;
              margin-bottom: 8px !important;
            }

            h4,
            h5 {
              font-size: 14px !important;
              margin: 5px 0 !important;
            }

            p,
            li,
            td,
            th,
            small {
              font-size: 12px !important;
              line-height: 1.3 !important;
              margin-bottom: 3px !important;
            }

            img {
              max-width: 80px !important;
            }

            hr {
              margin: 8px 0 !important;
              border: 1px solid #000 !important;
            }

            table {
              width: 100% !important;
              margin-bottom: 8px !important;
              border-collapse: collapse !important;
            }

            th,
            td {
              padding: 3px !important;
              border: 1px solid #000 !important;
            }

            @page {
              size: A4;
              margin: 5mm;
            }
          }
        `}
      </style>
    </>
  );
};

export default Prescriptionbill;
